import React, { useState } from 'react';
import LazyImage from '../LazyImage';
import './ChooseUs.css';
// Import images
import personIllustrator from '../../assets/images/person-illustrator.webp';
import bookIllustrator from '../../assets/images/book-illustrator.webp';
import taxIllustrator from '../../assets/images/tax-illustrator.webp';
import moneyIllustrator from '../../assets/images/money-illustrator.webp';
import chooseBanner from '../../assets/images/choose-banner.webp';
import chooseBannerSmall from '../../assets/images/choose-banner-sm.webp';
import clientSatisfaction from '../../assets/images/client_satisfaction.webp';

const ChooseUs = ({ color }) => {
    const [hoveredBar, setHoveredBar] = useState(null);

    const refundData = [
        { amount: '$100', height: 30 },
        { amount: '$1k', height: 40 },
        { amount: '$10k', height: 50 },
        { amount: '$15k', height: 60 },
        { amount: '$20k', height: 70 },
        { amount: '$25k', height: 80 },
        { amount: '$30k', height: 90 },
        { amount: '$35k', height: 100, active: true },
        { amount: '$50k', height: 110 }
    ];

    const features = [
        {
            icon: personIllustrator,
            title: "Professional, Qualified Tax Agents",
            description: "Your taxes are handled by certified experts with deep knowledge of Australian tax law and compliance standards."
        },
        {
            icon: bookIllustrator,
            title: "Year-Round Support & Guidance",
            description: "We're here for you beyond tax season — whether you need help mid-year, planning ahead, or facing an ATO query."
        },
        {
            icon: taxIllustrator,
            title: "Complete Coverage of Tax Matters",
            description: "From personal returns to complex tax scenarios, we manage it all — including deductions, investments, share sales, and more."
        },
        {
            icon: moneyIllustrator,
            title: "Reasonable, Tax-Deductible Fees",
            description: "Get premium service at fair, transparent rates — and yes, our fees are tax-deductible too."
        }
    ];

    return (
        <div className="choose-us" style={{ backgroundColor: color ? color : '#fff' }}>
            <div className="choose-us-container">
                <div className="choose-us-content">
                    {/* Left Column */}
                    <div className="choose-us-left">
                        <div className="choose-us-tag">Why Choose Us</div>

                        <h2 className="choose-us-title">
                            Trusted Expertise.<br />
                            <span className="text-primary">Real Value</span>.
                        </h2>

                        <p className="choose-us-description">
                            Partner with a team that delivers more than just tax services —
                            we offer peace of mind, professional advice, and year-round
                            support that puts you in control.
                        </p>

                        <div className="choose-us-features">
                            {features.map((feature, index) => (
                                <div key={index} className="feature-item">
                                    <div className="feature-icon">
                                        <LazyImage src={feature.icon} alt={feature.title} />
                                    </div>
                                    <div className="feature-content">
                                        <h3 className="feature-title">{feature.title}</h3>
                                        <p className="feature-description">{feature.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="choose-us-right">
                        {/* First Row - Tax Refund Card */}
                        <div className="info-card refund-card">
                            <div className="card-header">
                                <h3 className="card-title1">Average Tax Refund</h3>
                                <p className="card-description1">
                                    With strategic planning and deduction optimization, our clients get better results.
                                </p>
                            </div>

                            <div className="refund-chart">
                                {refundData.map((item, index) => (
                                    <div key={index} className="chart-bar-container">
                                        <div
                                            className={`chart-bar ${item.active ? 'active' : ''} ${hoveredBar === index ? 'hovered' : ''}`}
                                            style={{ height: `${item.height}px` }}
                                            onMouseEnter={() => setHoveredBar(index)}
                                            onMouseLeave={() => setHoveredBar(null)}
                                        ></div>
                                        <span className="chart-label">{item.amount}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Second Row - Banner Image */}
                        <div className="banner-image">
                            <LazyImage src={chooseBanner} smallSrc={chooseBannerSmall} alt="Tax planning and consultation" />
                        </div>

                        {/* Third Row - Two Cards */}
                        <div className="bottom-cards">
                            <div className="info-card satisfaction-card">
                                <h3 className="card-title">Client Satisfaction Score</h3>
                                <div className="satisfaction-chart">
                                    <LazyImage src={clientSatisfaction} alt="Client Satisfaction" />
                                </div>
                                <p className="card-description">
                                    Our clients consistently rate us highly for service quality,
                                    communication, and ease of process.
                                </p>
                            </div>

                            <div className="info-card support-card">
                                <h3 className="card-title">Year-Round Support</h3>
                                <div className="support-count">365 Days</div>
                                <div className="support-availability">Availability</div>
                                <p className="card-description">
                                    Unlike seasonal tax services,
                                    we're available all year — for
                                    advice, help, and proactive
                                    planning.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChooseUs;
